import { render, staticRenderFns } from "./PriceComparisonIframe.vue?vue&type=template&id=228dc34b&"
import script from "./PriceComparisonIframe.vue?vue&type=script&lang=ts&"
export * from "./PriceComparisonIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports